import { useActionFailedAlert } from "shared/problems/composables/actionFailedAlert";
import { useMapStyleStore } from "shared/mapStyles/stores/mapStyleStore";
import { useListMapStyles } from "./listMapStyles";

export function useInitializeMapStylesStore() {
  const store = useMapStyleStore();
  const list = useListMapStyles();
  const actionFailedAlert = useActionFailedAlert();

  return {
    execute
  };

  async function execute() {
    if (store.initialized) return;

    try {
      store.loading = true;
      const response = await list.execute();

      if (response.ok) {
        store.initialized = true;
      } else {
        actionFailedAlert.show(response.details);
      }

      return response;
    } finally {
      store.loading = false;
    }
  }
}
